// Requisição abortada por AbortController (troca de ticket/aba, unmount): não é
// erro — a tela que a pediu já não existe. Axios usa CanceledError/ERR_CANCELED;
// fetch nativo usa AbortError.
export const isRequestCanceled = (err) =>
  err?.code === "ERR_CANCELED" ||
  err?.name === "CanceledError" ||
  err?.name === "AbortError";
